<script setup lang="ts">
import type { PropType } from 'vue'
import type { TocLink } from '@nuxt/content/dist/runtime/types'

defineProps({
    links: {
        type: Array as PropType<TocLink[]>,
        default: () => []
    },
    nested: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['move'])

const route = useRoute()
const router = useRouter()

const { activeHeadings, updateHeadings } = useScrollspy()

const scrollToHeading = (id: string) => {
    router.push(`#${id}`)
    emit('move', id)
}
</script>

<template>
    <ol class="list-inside text-base" :class="[nested ? 'list-disc' : 'list-decimal']">
        <li v-for="link in links" :key="link.text" class="min-w-0 group"
            :class="[{ 'pl-3': link.depth === 3, 'pl-6': link.depth === 4 }]">
            <a :href="`#${link.id}`" class="inline-block py-1 hover:text-primary-500 max-w-max text-base"
                :title="link.text" @click.prevent="scrollToHeading(link.id)">
                {{ link.text }}
            </a>
            <DocsTocLinksInContent v-if="link.children" :links="link.children" :nested="true" />
        </li>
    </ol>
</template>
